// Pro API - Project Photo Operations
import { request, uploadFile } from "../base";
import type { ProjectPhoto } from "./types";

export const photosApi = {
	async list(proId: string, projectId: string) {
		return request<ProjectPhoto[]>(
			`/api/pro/${proId}/projects/${projectId}/photos`,
		);
	},

	async add(
		proId: string,
		projectId: string,
		data: { image: string; caption?: string },
	) {
		return request<ProjectPhoto>(
			`/api/pro/${proId}/projects/${projectId}/photos`,
			{
				method: "POST",
				body: data,
			},
		);
	},

	// Upload a photo file directly to R2 and create photo record
	async upload(
		proId: string,
		projectId: string,
		file: File,
		caption?: string,
	) {
		return uploadFile<ProjectPhoto>(
			`/api/pro/${proId}/projects/${projectId}/upload-photo`,
			file,
			caption ? { caption } : undefined,
		);
	},

	async update(
		proId: string,
		photoId: number,
		data: { caption?: string; sort?: number },
	) {
		return request<ProjectPhoto>(`/api/pro/${proId}/photos/${photoId}`, {
			method: "PUT",
			body: data,
		});
	},

	async delete(proId: string, photoId: number) {
		return request(`/api/pro/${proId}/photos/${photoId}`, {
			method: "DELETE",
		});
	},

	async reorder(proId: string, projectId: string, photoIds: number[]) {
		return request(
			`/api/pro/${proId}/projects/${projectId}/photos/reorder`,
			{
				method: "POST",
				body: { photoIds },
			},
		);
	},
};
